import { render } from "./InternalMark.vue?vue&type=template&id=090a5cc7&scoped=true"
import script from "./InternalMark.vue?vue&type=script&lang=js"
export * from "./InternalMark.vue?vue&type=script&lang=js"

import "./InternalMark.vue?vue&type=style&index=0&id=090a5cc7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090a5cc7"]])

export default __exports__